import React from "react";
import SectionHeading from "./SectionHeading";

const row1 = [
  "TensorRT",
  "PyTorch",
  "TensorFlow",
  "JAX",
  "Hugging Face",
  "LangChain",
  "LlamaIndex",
  "OpenAI API",
  "Anthropic",
  "Mistral AI",
];

const row2 = [
  "Weaviate",
  "Qdrant",
  "Milvus",
  "PostgreSQL",
  "Kubernetes",
  "Docker",
  "Ray",
  "MLFlow",
  "DVC",
  "Weights & Biases",
];

const Pill = ({ name, color }) => (
  <div className="flex items-center gap-3 px-6 py-4 rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl whitespace-nowrap">
    <span
      className={`w-2.5 h-2.5 rounded-full ${color === "cyan" ? "bg-cyan-400" : "bg-[#6B5AE6]"
        }`}
    />
    <span className="text-gray-300 text-lg font-medium">{name}</span>
  </div>
);

export default function TechStack() {
  return (
    <section className="bg-[#05071b] py-20 overflow-hidden border-t border-white/5">
      <div className="mb-12">
        <SectionHeading
          eyebrow="Tech Stack"
          title="Built With The Best Tools In AI"
          theme="dark"
          titleClassName="text-white"
          showLine={false}
          eyebrowClassName="text-cyan-400"
          descriptionClassName="hidden"
        />
      </div>

      {/* Row 1 */}
      <div className="relative flex overflow-hidden mb-6">
        <div className="animate-marquee flex gap-6">
          {[...row1, ...row1].map((item, i) => (
            <Pill
              key={i}
              name={item}
              color={i % 2 === 0 ? "purple" : "cyan"}
            />
          ))}
        </div>
      </div>

      {/* Row 2 */}
      <div className="relative flex overflow-hidden">
        <div className="animate-marquee-reverse flex gap-6">
          {[...row2, ...row2].map((item, i) => (
            <Pill
              key={i}
              name={item}
              color={i % 2 === 0 ? "cyan" : "purple"}
            />
          ))}
        </div>
      </div>
    </section >
  );
}